exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._3m6vg1ClmiG23f45PQHIZ7{margin-right:-8px}html[dir=rtl] ._3m6vg1ClmiG23f45PQHIZ7{margin-left:-8px}._12HmMKE4cZNa6daBuIz2Vb{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2zA9-0xZOCReerBDn6yvu7{font-size:21px}html[dir] ._2zA9-0xZOCReerBDn6yvu7{padding-top:8px}", ""]);
// Exports
exports.locals = {
	"closeButton": "_3m6vg1ClmiG23f45PQHIZ7",
	"customRecurrenceHeaderContainer": "_12HmMKE4cZNa6daBuIz2Vb",
	"customRecurrenceHeaderText": "_2zA9-0xZOCReerBDn6yvu7"
};